import { useEffect, useMemo } from "react";
import { Title, Text, Anchor, Stack, Box } from "@mantine/core";
import { legalTargets, type LegalDoc } from "@/lib/legal-links";

const TITLES: Record<LegalDoc, { en: string; sv: string }> = {
  privacy: { en: "Privacy policy", sv: "Integritetspolicy" },
  terms: { en: "Terms of use", sv: "Användarvillkor" },
};

/**
 * /privacy and /terms (old links keep working) send the member on to the published document on
 * the environment's site. The links stay visible as the fallback if the redirect does not happen.
 */
export function LegalRedirect({ doc }: { doc: LegalDoc }) {
  const { target, sv, en } = useMemo(() => legalTargets(doc), [doc]);
  useEffect(() => {
    window.location.replace(target);
  }, [target]);
  const t = TITLES[doc];
  return (
    <Box mih="100vh">
      <Stack maw={480} mx="auto" p="xl" gap="md" ta="center">
        <Title order={1} fz="xl" fw={700}>{t.en}</Title>
        <Text fz="sm" c="dimmed">Opening the document on {new URL(target).hostname}…</Text>
        <Text fz="sm">
          <Anchor href={en} td="underline">{t.en}</Anchor>
          {" · "}
          <Anchor href={sv} td="underline" lang="sv">{t.sv}</Anchor>
        </Text>
      </Stack>
    </Box>
  );
}
